// extracted by mini-css-extract-plugin
module.exports = {"cls":"DoughProFreeCookieTimer_cls__2Fxqr"};